module.exports = __webpack_public_path__ + "img/s1.05a4dab5.png";